import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import { LoadCreditSlotsError, LoadCreditSlots, LoadCreditSlotsSuccess, LoadMainPlan, LoadMainPlanSuccess } from '../action/credit-slots.action';
import type { CreditSlotsState } from '../state/credit-slots.state';
import { initialCreditSlotsState } from '../state/credit-slots.state';

const creditSlotsReducer = createReducer(
  initialCreditSlotsState,

  on(LoadCreditSlots, (state: CreditSlotsState) => ({
      ...state,
      loading: true,
      loaded: false,
      error: null,
    })),

  on(LoadCreditSlotsSuccess, (state: CreditSlotsState, { overviewData }) => ({
      ...state,
      creditSlots: overviewData.creditSlots,
      mainPlan: overviewData.mainPlan,
      trialEndDate: overviewData.trialEndDate,
      loaded: true,
      loading: false,
    })),

  on(LoadCreditSlotsError, (state: CreditSlotsState, { error }) => ({
      ...state,
      error,
      loading: false,
      loaded: true,
    })),

  on(LoadMainPlan, (state: CreditSlotsState) => ({
      ...state,
      loading: true,
      loaded: false,
    })),

  on(LoadMainPlanSuccess, (state: CreditSlotsState, { mainPlan, upgradeData }) => ({
      ...state,
      mainPlan,
      upgradeData,
      loading: false,
      loaded: true,
    })),

  on(LoadCreditSlotsError, (state: CreditSlotsState, { error }) => ({
      ...state,
      error,
      loading: false,
      loaded: true,
    })),
);

export function CreditSlotsReducer(state: CreditSlotsState | undefined, action: Action): CreditSlotsState {
  return creditSlotsReducer(state, action);
}
